import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ExternalLinkPage from './externalLink/ExternalLinkPage';
import { ProfilePage } from './pages';

const App = () => {
  /*****************************************
   * Routes for the application defined here
   *****************************************/

  return (
    <>
      <Router>
        <Routes>
          <Route path='/profile/:id' element={<ProfilePage />} />
          <Route path='*' element={<ExternalLinkPage />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
